import initialState from './ReservationInitialState';
import reducers from './ReservationReducer';

export default {
  initialState,
  reducers,
};
